export default __webpack_public_path__ + "static/media/avatar.0f34ce28.png";